import {
  CREATE_PROJECT_START,
  SET_PROJECTS_INIT,
  FETCH_PROJECT_START,
  UPDATE_PROJECT_START,
  COPY_PROJECT_START,
  FETCH_MASTER_PROJECT_START,
  FETCH_PACKAGE_START,
  CREATE_PACKAGE_START,
  RESET_PKGS_TAGS,
  CREATE_TAG_START,
  FETCH_TAGS_START,
  UPDATE_TAGS_START,
  FETCH_ADNAMES_START,
  FETCH_ADNAMES_SUCCESS,
  CREATE_PKG_START,
  FETCH_PKGS_START,
  UPDATE_PKG_START, UPDATE_PKG_SUCCESS, UPDATE_PKG_FAILURE, CREATE_TTYPE_START, FETCH_TTYPES_START, FETCH_TAG_COUNT_START, FETCH_TAGS_CANCEL, FETCH_ARCHIVE_CANCEL, COPY_TAGS_START, REMOVE_TAGS_START,
  ADD_UPDATE_PRICE_CONFIG, GET_REPORT_START, GET_REPORT_SUCCESS, GET_REPORT_FAILURE, FETCH_MODEL_BREAK_START, FETCH_MODEL_BREAK_MUL_START,
  REPORT_BATCHES_START,
  FETCH_REPORT_HUB_STATUS_START,
  REPORTHUB_TASK_STATUS_START, SEND_MAIL_START,
  BULK_TAG_CONFIG_START,
  BULK_TAG_CONFIG_STS_START,
  SEND_PRICING_DATA_START,
  SEND_PRICING_DATA_SUCCESS,
  SEND_PRICING_DATA_FAILURE,
  BULK_TAG_CONFIG_CANCEL_START,
  FETCH_TAG_COUNT_PKG_START,
  FETCH_TAGS_SUCCESS,
  FETCH_TAGS_FAILURE,
  FETCH_TAG_COUNT_SUCCESS,
  PRICE_ITEM_START,
  ITEM_PRICE_STS_START,
  QUOTE_SEARCH_START,
  FETCH_TAGS_WITH_CMNT_START,
  FETCH_PKG_CMT_HISTORY_START,
  UPDATE_PKG_CMT_START,
  EDIT_PKG_CMT_START,
  CONF_IT_MODEL_STRING_BREAKDOWN_START
} from "./projTypes";
import { takeLatest, put, call, all, delay, fork, cancel, takeLeading, takeEvery } from "@redux-saga/core/effects";
import {
  createProjectAPI,
  copyProjectAPI,
  getProjectsAPI,
  updateProjectAPI,
  getMasterProjectsAPI,
  getPkgAPI,
  createPkgAPI,
  createTagAPI,
  getTagsApi,
  updTagAPi,
  chkAccAPI,
  getADSearchAPI,
  crpKGAPI,
  getPkgsAPI,
  upPkgAPI,
  crTechTypeAPI,
  fetchTTAPI,
  getPrjCnt,
  getPrjAPI,
  getLPAPI,
  getTagCnt,
  copyTagAPI,
  removeTagAPI,
  getModelBreak,
  addUpdatePriceConfig,
  postReportBatchesAPI,
  getReportAPI,
  reportHubStatus,
  getReportHubStatus,
  getRptHubTkStt,
  reportHubStatusUpd,
  getAllPrjAPI,
  getModelBreakMulTag,
  emailNotiSendAPI,
  postBulkConfigtag,
  bulkConfigtagsstus,
  pricingAPI,
  cancelBulkConfigtag,
  itemPriceSubmitApi,
  itemPriceStatusApi,
  quoteSearchApi,
  getTagsApiWithRemarks,
  getPkgHistoryCmnt,
  updatePkgRevComment,
  editPkgRevComment,
  confITModelBreakdownAPI
} from "../../apis/pgapis";
import {
  createProjectSucc,
  createProjectFailure,
  fetchProjectSuccAct,
  fetchProjectFailAct,
  setProjInitAct,
  updateProjectSuccAct,
  updateProjectFailAct,
  copyPorjectSucc,
  copyPorjectFail,
  fetchMasterProjectsSucc,
  fetchMasterProjectsFailure,
  fetchPkgSuccAct,
  fetchPkgFailAct,
  createPkgSuccAct,
  createPkgFailAct,
  resetPkgsTagsAct,
  createTagSuccAct,
  createTagFailAct,
  fetchTagsSuccAct,
  fetchTagsFailAct,
  updtTagFailAct,
  updTagSuccAct,
  chkAccSuccAct,
  chkAccFailAct,
  fetchADNSuccAct,
  fetchADNFailAct,
  crPkgSucc,
  fPkgsSuccAct,
  fPkgsFailAct,
  upPkgSuccAct,
  upPkgFailAct,
  createTTAct,
  createTTSuccAct,
  createTTFailureAct,
  fTTActSuccAct,
  fTTActFailAct,
  fetchAllProjectSuccAct,
  fetchTTColumnsLkpSucc,
  fetchTagCountSucc,
  fetchTagCountFail,
  fTTAct,
  fetchTagsAct,
  updtProgressCntAct,
  showProgressBarAct,
  fetchProjectsAct,
  createCopyTagSucc,
  createCopyTagFailure,
  fetchTagCountAct,
  resetTagsAct,
  removeChildTagSucc,
  removeChildTagFailure,
  fmodelbreakSuccAct,
  fmodelbreakFailAct,
  addUpdatePriceConfigFailure,
  updTagAct,
  updTagRes,
  userExpireLogout,
  getReportIDUpdate,
  submitReportBatchesSuccess,
  submitReportBatchesFailure,
  fetchReportHubStatusSucc,
  reportHubTaskStatusUpdate,
  fModelBreakMulSuccAct,
  fModelBreakMulFailAct,
  sendMailFailure,
  sendMailSuccess,
  copyPackgeSuccess,
  bulkTagConfigFailure,
  bulkTagConfigSuccess,
  bulkTagConfigStatusSuccess,
  postpricingdatastart,
  postpricingdataSuccess,
  postpricingdataFailure,
  bulkTagConfigStatusStart,
  bulkTagConfigCancelSuccess,
  bulkTagConfigCancelFailure,
  bulkTagConfigStatusFailure,
  fetchTagCountPkgSucc,
  getReport,
  startLoader, stopLoader,
  itemPriceStatusSuccess,
  itemPriceStatusFailure,
  priceItemSuccess,
  priceItemFailure,
  // addUpdatePriceConfigSuccess
  quoteSearchSuccess,
  quoteSearchFailure,
  fetchTagsWithCmntSuccess,
  fetchTagsWithCmntFailure,
  fetchPkgCmntHistorySuccess,
  fetchPkgCmntHistoryFailure,
  fetchPkgCmntHistoryStart,
  updatePkgCmntFailure,
  updatePkgCmntSuccess,
  updatePkgCmntDelete,
  editPkgCmntFailure,
  editPkgCmntSuccess,
  changeLoadingPhaseStatus,
  confITModelBreakdownFailure

} from "../project/projActions";
import { fetchTechTypFailAct, fetchTechTypSuccAct, showLoader, refreshApp } from "../ctrl/ctrlActions";
import { batch, useDispatch } from "react-redux";
import { select, take } from 'redux-saga/effects';
import { updateReviStartAct } from "../revision/revAction";
import { getDt, getEnvironment } from '../../../utils';
import toastr from 'toastr';


let abortControllerArr = [];
let abortControllerArrBulkConfig = []
let cancledApi = false;
let totalReqLeft = 0;
let projectTotalReqLeft = 0;
const getTags = (state) => state.project.tags;

const getTagCount = (state) => state.project.gettagcnt;
const getTechTypes = (state) => state.project.techTyps;
const getDelTags = (state) => state.project.deletedTags;
export function* onCreateProjAsync(payload) {
  try {
    const response = yield call(createProjectAPI, payload);
    if (response.status === 200) {
      localStorage.setItem("NR", "NR");
      yield put(createProjectSucc(response.data));
      /*try {
        const response = yield call(getProjectsAPI, payload.payload);
        yield put(fetchProjectSuccAct(response));
        localStorage.setItem("NR", "NR");
      } catch (e) {
        console.log("Error getProjectsAPI ", e);
        yield put(fetchProjectFailAct(e));
      }*/
    }
  } catch (e) {
    if (e?.response?.status === 403) { yield put(refreshApp(true)) }
    console.log("Error onCreateProjAsync ", e);
    yield put(createProjectFailure(e));
  }
}

export function* onCreateProj() {
  yield takeLatest(CREATE_PROJECT_START, onCreateProjAsync);
}

export function* onUpdateProjAsync(payload) {
  try {
    const response = yield call(updateProjectAPI, payload);
    // console.log("response",response)
    if (response.status === 200) {

      yield put(updateProjectSuccAct(response.data));

      //  yield put(fetchProjectSuccAct({response,onUpdateProjAsync:true}));

      try {
        yield put(fetchProjectSuccAct({ response, onUpdateProjAsync: true }));
      } catch (e) {
        if (e?.response?.status === 403) { yield put(refreshApp(true)) }
        // console.log("Error getProjectsAPI ", e);
        yield put(fetchProjectFailAct(e));
      }
    }
  } catch (e) {
    console.log("Error updateProjectFailAct ", e);
    yield put(updateProjectFailAct(e));
  }
}

export function* onUpdateProj() {
  yield takeLatest(UPDATE_PROJECT_START, onUpdateProjAsync);
}

// export function* onFetchProjectsAsync({ payload }) {
//   try {    
//     yield put(showLoader(true));    
//     var response;
//     if(payload.fromNo) {
//       response = yield call(getPrjAPI, {...payload});
//     } else {
//       response = yield call(getPrjAPI, {...payload, fromNo: 1, toNo: 2000});
//     }
//     yield put(fetchProjectSuccAct(response));
//     yield put(showLoader(false));   
//   } catch (e) {
//     console.log(e);
//     yield put(fetchProjectFailAct(e));
//   }
// }

function* fetchAllProj({ splitNumber, payload }) {
  var fromNo = 0;
  var toNo = 2000;
  yield all(splitNumber.map((count, i) => {
    if (i > 0) {
      fromNo = toNo + 1;
      toNo = count < 2000 ? payload.prjCnt : toNo + count;
      var response = fork(getPrj, { ...payload, fromNo: fromNo - 1, toNo });
      return response;
    }
  }))
  yield delay(1000)
}

function* fetchAllProject({ splitNumber, payload }) {
  var fromNo = 0;
  var toNo = 2000;
  for (let i = 0; i < splitNumber.length; i++) {
    const count = splitNumber[i];
    if (i > 0) {
      fromNo = toNo + 1;
      toNo = count < 2000 ? payload.totalProjectCount : toNo + count;
      const state = yield select(state => state.profile);
      var response = yield fork(getProjects, { ...payload, fromNo: fromNo - 1, toNo, bu_name: state.bu });
      projectTotalReqLeft += 1;
      let dly = 3500;
      if (projectTotalReqLeft >= 4) {
        dly = 5000;
      }
      if (projectTotalReqLeft >= 6) {
        dly = 8000;
      }
      if (projectTotalReqLeft >= 7) {
        dly = 10000;
      }
      if (projectTotalReqLeft >= 8) {
        dly = 15000;
      }
      yield delay(dly);
      // return response;
    }
  }
}

function* getPrj(payload) {
  const response = yield call(getPrjAPI, payload)
  yield put(fetchAllProjectSuccAct(response))
}
function* getProjects(payload) {
  const response = yield call(getAllPrjAPI, { ...payload })
  projectTotalReqLeft -= 1;
  yield put(fetchAllProjectSuccAct(response))
}

export function* onFetchProjectsAsync({ payload }) {
  try {
    //yield put(showLoader(true));
    // const response = yield call(getProjectsAPI, payload);    
    yield put(showLoader(true));
    const prj_count = payload.prjCnt ? payload.prjCnt : 1;
    const prj_countAll = payload.totalProjectCount ? payload.totalProjectCount : 1;
    var splitNumber = new Array(Math.floor(prj_count / 2000)).fill(2000).concat(prj_count % 2000);
    var fromNo = 0;
    var toNo = 2000;
    const state = yield select(state => state.profile)
    if (payload.capabilities.findIndex((o) => o.PWSALPRJ === 'Y') >= 0) {
      var splitNumber = new Array(Math.floor(prj_countAll / 2000)).fill(2000).concat(prj_countAll % 2000);
      const response = yield call(getAllPrjAPI, { ...payload, fromNo: 0, toNo: 2000, bu_name: state.bu });

      yield put(fetchProjectSuccAct(response));
      yield put(showLoader(false));

      // }else{
      // const response = yield call(getPrjAPI, {...payload, fromNo: 1, toNo: 2000});
      // //const response = yield call(getPrjAPI, payload); 
      //  // console.log("response123",response)   
      // yield put(fetchProjectSuccAct(response));
      // yield put(showLoader(false));   
      try {
        yield call(fetchAllProject, { splitNumber, payload });
      } catch (e) {
        if (e?.response?.status === 403) { yield put(refreshApp(true)) }
        console.log("fetchAllProject Error:", e)
      }
    } else {
      const response = yield call(getPrjAPI, { ...payload, fromNo: 0, toNo: 2000, bu_name: state.bu });
      //const response = yield call(getPrjAPI, payload); 
      // console.log("response123",response)   
      yield put(fetchProjectSuccAct(response));
      yield put(showLoader(false));
      try {
        yield call(fetchAllProj, { splitNumber, payload });
      } catch (e) {
        if (e?.response?.status === 403) { yield put(refreshApp(true)) }
        console.log("fetchAllProj Error:", e)
      }
    }
  } catch (e) {
    if (e?.response?.status === 403) { yield put(refreshApp(true)) }
    console.log(e);
    yield put(fetchProjectFailAct(e));
  }
}

export function* onFetchProjects() {
  yield takeLatest(FETCH_PROJECT_START, onFetchProjectsAsync);
}

export function* onSetProjectsSync() {
  const response = yield call(setProjInitAct);
}

export function* onSetProjects() {
  yield takeLatest(SET_PROJECTS_INIT, onSetProjectsSync);
}

export function* onCopyProjectAsync(payload) {
  try {
    const response = yield call(copyProjectAPI, payload);
    if (response.status === 200) {
      localStorage.setItem("NR", "NR");
      yield put(createProjectSucc(response.data[0]));
      //yield put(showLoader(false));
    }
    //console.log('-------------------- response ',response);
    /*if (response === 200) {
      yield put(copyPorjectSucc());
      try {
        const response = yield call(getProjectsAPI, payload.payload);
        yield put(fetchAllProjectSuccAct(response));
      } catch (e) {
        console.log("Error getProjectsAPI ", e);
        yield put(fetchProjectFailAct(e));
      }
    }*/
  } catch (e) {
    if (e?.response?.status === 403) { yield put(refreshApp(true)) }
    console.log("Error onCopyProjAsync ", e);
    yield put(copyPorjectFail(e));
  }
}

export function* onCopyProject() {
  yield takeLatest(COPY_PROJECT_START, onCopyProjectAsync);
}

export function* onFetchMasterProjects() {
  yield takeLatest(FETCH_MASTER_PROJECT_START, onFetchMasterProjectsAsync);
}

export function* onFetchMasterProjectsAsync(payload) {
  try {
    let response = yield call(getMasterProjectsAPI);
    response = response.filter((elem) => {
      //console.log('payload.currMproj=================== ',payload.currMproj)
      return (
        elem.proj_list.toLowerCase().includes(payload.payload.toLowerCase()) &&
        elem.proj_list !== payload.currMproj
      );
    });
    yield put(fetchMasterProjectsSucc(response));
  } catch (error) {
    if (error?.response?.status === 403) { yield put(refreshApp(true)) }
    console.log(error);
    yield put(fetchMasterProjectsFailure(error));
  }
}

export function* onFetchPkgsAsync(payload) {
  try {
    const response = yield call(getPkgAPI, payload);
    console.log(response)
    yield put(fetchPkgSuccAct(response));
  } catch (e) {
    if (e?.response?.status === 403) { yield put(refreshApp(true)) }
    yield put(fetchPkgFailAct(e));
  }
}

export function* onFetchPkgs() {
  yield takeLatest(FETCH_PACKAGE_START, onFetchPkgsAsync);
}

export function* onCreatePkgAsync(payload) {
  try {
    const response = yield call(createPkgAPI, payload);
    if (response.status === 200) {
      yield put(createPkgSuccAct(response.data));
      yield put(showLoader(false));
    }
  } catch (e) {
    if (e?.response?.status === 403) { yield put(refreshApp(true)) }
    console.log("Error onCreateProjAsync ", e);
    yield put(createPkgFailAct(e));
  }
}

export function* onCreatePkg() {
  yield takeLatest(CREATE_PACKAGE_START, onCreatePkgAsync);
}

export function* onResetPkgsTagsSync() {
  yield put(resetPkgsTagsAct);
}

export function* onResetPkgsTags() {
  yield takeLatest(RESET_PKGS_TAGS, onResetPkgsTagsSync);
}

export function* onCreateTagAsync(payload) {
  try {
    const autoCreateTechType = payload.autoCreateTechType;

    // Preserve the existing create-tag behavior when no tech-type payload is supplied.
    if (!autoCreateTechType) {
      const response = yield call(createTagAPI, payload);
      if (response.status === 200) {
        yield put(createTagSuccAct(response.data));
        yield put(showLoader(false));
      }
      return;
    }

    let tagPayload = payload.payload;

    const projectTechTypes = yield select((state) => state.project.techTyps);
    let selectedTechType = projectTechTypes.find(
      (techType) =>
        techType.technology_name === autoCreateTechType.technology_name &&
        techType.instrument_type === autoCreateTechType.instrument_type &&
        techType.product_description === autoCreateTechType.product_description
    );

    if (!selectedTechType) {
      const techTypeResponse = yield call(crTechTypeAPI, [autoCreateTechType]);

      if (techTypeResponse.status !== 200) {
        throw new Error("Technology type creation failed");
      }

      selectedTechType = techTypeResponse.data?.[0] || techTypeResponse.data;
      yield put(createTTSuccAct(techTypeResponse.data));
    }

    tagPayload = Object.keys(tagPayload).reduce((groupedTags, key) => {
      groupedTags[key] = tagPayload[key].map((tag) => ({
        ...tag,
        technology_name: selectedTechType.technology_name,
        gen_technology_type: selectedTechType.technology_name,
        gen_instrument_type: selectedTechType.instrument_type,
        gen_prod_desc: selectedTechType.product_description,
        technology_id: selectedTechType.technology_id?.toString(),
        revision: selectedTechType.revision || tag.revision,
      }));
      return groupedTags;
    }, {});

    const response = yield call(createTagAPI, { ...payload, payload: tagPayload });
    if (response.status === 200) {
      yield put(createTagSuccAct(response.data));
      yield put(showLoader(false));
    }
  } catch (e) {
    if (e?.response?.status === 403) { yield put(refreshApp(true)) }
    console.log("Error onCreateProjAsync ", e);
    yield put(showLoader(false));
    yield put(createTagFailAct(e));
  }
}

export function* onCreateTag() {
  yield takeLatest(CREATE_TAG_START, onCreateTagAsync);
}

let failedArr = [];
let processedDataCount = 0;
let failProcessed = 0

function* getTag(payload) {
  let abortController1 = new AbortController();
  abortControllerArr.push(abortController1)
  const response = yield call(getTagsApi, { ...payload, signal: abortController1.signal });
  processedDataCount += payload.count;
  console.log("count", payload.count)
  console.log("processedDataCount", processedDataCount)
  let indx = failedArr.findIndex(e => e.fromNo === payload.fromNo);

  if (response.response?.status === 500) {
    //console.log(response.response);
    console.log(payload);
    if (indx === -1) {
      failedArr.push(payload)
    }

    console.log(failedArr);
    failProcessed += payload.count;
    console.log("failProcessed", failProcessed)
  }

  if (!response?.length && !response.response?.status && !response?.response?.status) {
    // Failed Condition will Trigger Here
    if (indx === -1) {
      failedArr.push(payload)
    }
  }

  // yield put(fetchAllProjectSuccAct(response))
  if (response?.length > 0) {
    totalReqLeft -= 1;

    if (indx !== -1) {
      failedArr.splice(indx, 1);
    }
    // processedDataCount += payload.count;
    yield put(updtProgressCntAct(payload.count));
    yield put(fetchTagsSuccAct(response));

  }


  let tagCntTL = 0;
  for (let value of Object.values(payload.payload.tagCnt)) {
    tagCntTL += value;
  }

  if (failProcessed > 0) {
    console.log(failedArr);
    processedDataCount = 0;
    let f = failProcessed;
    failProcessed = 0
    let tempArr = [...failedArr];
    failedArr = [];
    if (tempArr.length > 0) {
      for (let i = 0; i < tempArr.length; i++) {
        if (cancledApi) { break }
        let oj = { ...tempArr[i] }
        oj["payload"] = { ...oj.payload, tagCnt: f }
        console.log(oj)
        yield fork(getTag, oj)
        yield delay(2000);
      }
    } else {
      yield put(showProgressBarAct({ isShow: false, fetchedDataCnt: 0 }));

    }
  }
}

const sizePL = 1000;
let splitbyType = [];
let techType = null;

function* fetchAlltags({ splitbyType, payload }) {
  var fromNo = 0;
  var toNo = sizePL;
  processedDataCount += toNo;
  // yield all(splitNumber.map((count, i) => {
  //   if(i > 0) {

  //     fromNo = toNo + 1;
  //     toNo = count < 1000 ? payload.payload.tagCnt : toNo + count;
  //     //var response = fork(getTag, {...payload, fromNo: fromNo, toNo: toNo});

  //   //  return response;
  //   }
  // }))
  // yield delay(1500)
  let istart = 1;
  for (let ip = 0; ip < splitbyType.length; ip++) {
    let techTypeDB = Object.keys(splitbyType[ip])[0]
    techType = techTypeDB.replace(/tag_count|_/g, ' ').trim();
    let splitValue = Object.values(splitbyType[ip])[0];
    for (let i = istart; i < splitValue.length; i++) {
      if (cancledApi) { break }
      let count = splitValue[i];
      fromNo = toNo + 1;
      let tagCountNW = Object.entries(payload.payload.tagCnt).filter(([key]) => key === techTypeDB);
      toNo = count < sizePL ? tagCountNW[0][1] : toNo + count;
      console.log('from saga fork count ', fromNo + "-to-" + toNo + "-count-" + count)
      if (count !== 0) {
        yield fork(getTag, { ...payload, fromNo: fromNo, techType: techType, toNo: toNo, count });
        // yield fork(crUpdtRevs, { recordsArr: sdata.splice(fromNo, count), pkg: payload.pkg, ttlCnt: pl_count, count });
      }
      totalReqLeft += 1;
      let dly = 500;
      if (totalReqLeft > 3) {
        dly = 2000;
      }
      if (totalReqLeft >= 6) {
        dly = 6000;
      }
      if (totalReqLeft >= 8) {
        dly = 12000;
      }
      if (totalReqLeft >= 10) {
        dly = 16000;
      }

      console.log("totalReqLeft " + totalReqLeft + " delay " + dly);
      yield delay(dly);
      if (ip + 1 === splitbyType.length && i + 1 === splitValue.length) {
        splitbyType = [];
        techType = null;
      }


    }
    toNo = 0;
    fromNo = 0;
    istart = 0;

  }




  // for (let i = 1; i < splitNumber.length; i++) {
  //   if(cancledApi){break}
  //   let count = splitNumber[i];
  //   fromNo = toNo + 1;
  //   toNo = count < sizePL ? payload.payload.tagCnt.DP_Flow_tag_count : toNo + count;
  //   console.log('from saga fork count ', fromNo + "-to-" + toNo +"-count-" +count)
  //   if (count !== 0) {
  //     yield fork(getTag, {...payload, fromNo: fromNo, techType: "DP Flow", toNo: toNo,count});
  //    // yield fork(crUpdtRevs, { recordsArr: sdata.splice(fromNo, count), pkg: payload.pkg, ttlCnt: pl_count, count });
  //   }
  //   yield delay(2000);

  // }

}

function* callTagFirst(payload) {
  console.log(payload);
  const response = yield call(getTagsApi, payload);

  if (response.response?.status === 500) {
    yield fork(callTagFirst, payload)
  }
  if (response?.length > 0) {
    yield put(fetchTagsSuccAct(response));
    yield put(showLoader(false));
  }
}

export function* onFetchTagsAsync(payload) {
  try {
    yield put(showLoader(true));
    abortControllerArr.length = 0
    cancledApi = false
    failedArr = [];
    processedDataCount = 0;
    failProcessed = 0;
    splitbyType = [];
    techType = null;
    let tagCntbyType = payload.payload.tagCnt;
    if (tagCntbyType) {
      Object.keys(tagCntbyType).map((i) => {
        if (tagCntbyType[i] > 0 && !techType) {
          techType = i.replace(/tag_count|_/g, ' ')?.trim();
        }
        if (tagCntbyType[i] > 0) {
          let tCnt = tagCntbyType[i];
          let split = new Array(Math.floor(tCnt / sizePL)).fill(sizePL).concat(tCnt % sizePL);
          var slt = {
            [i]: split,
          };
          splitbyType.push(slt);
        }
      })
    }

    let tagCntTL = 0;
    for (let value of Object.values(payload.payload.tagCnt)) {
      tagCntTL += value;
    }
    if (techType == null || techType == undefined) {
      yield put(fetchTagsSuccAct([]));
      yield put(showLoader(false));
      return
    }

    const tagCnt = payload.payload.tagCnt ? tagCntTL : 1;
    yield put(showProgressBarAct({ isShow: false, ttlDataCount: tagCnt, fetchedDataCnt: 0 }));
    // var splitNumber = new Array(Math.floor(tagCnt / sizePL)).fill(sizePL).concat(tagCnt % sizePL);
    var fromNo = 1;
    var toNo = sizePL;
    let abortController = new AbortController();
    let response = yield call(getTagsApi, { ...payload, fromNo: fromNo, techType: techType, toNo: toNo, signal: abortController.signal });
    if (response.response?.status === 500) {
      response = yield call(getTagsApi, { ...payload, fromNo: fromNo, techType: techType, toNo: toNo, signal: abortController.signal })
      if (response.response?.status === 500) {
        console.log(response);
        yield put(fetchTagsFailAct());
      }

    }

    yield put(fetchTagsSuccAct(response));
    yield put(showLoader(false));
    if (response?.length > 0) {
      let splitObject = Object.values(splitbyType[0])[0];
      if ((splitObject.length > 1 || splitbyType.length > 1) && splitObject[1] != 0) {
        yield put(showProgressBarAct({ isShow: true, ttlDataCount: tagCnt, fetchedDataCnt: parseInt(splitObject) }));
        try {
          yield call(fetchAlltags, { splitbyType, payload });
        } catch (e) {
          if (e?.response?.status === 403) { yield put(refreshApp(true)) }
          if (e) {
            console.log("fetchAlltags Error:", e)
          }

        }

      }



      //   if(splitNumber.length>1 && splitNumber[1]!=0){
      //   yield put(showProgressBarAct({ isShow: true,ttlDataCount:payload.payload.tagCnt, fetchedDataCnt: 1000}));
      //   try {
      //     yield call(fetchAlltags, {splitNumber, payload});
      //   } catch (e) {
      //     console.log("fetchAlltags Error:", e)
      //   }
      // }
    }

  } catch (e) {
    if (e?.response?.status === 403) { yield put(refreshApp(true)) }
    yield put(fetchTagsFailAct(e));
  }
}


export function* onFetchTags() {
  yield takeLatest(FETCH_TAGS_START, onFetchTagsAsync);
}

export function* onFetchTagsCancelAsync() {
  cancledApi = true;
  abortControllerArr.forEach(e => {
    e.abort();
  })
  abortControllerArrBulkConfig.forEach(e => {
    e.abort();
  })


  // yield cancel()
}


export function* onCancleFetchTags() {

  yield takeLatest(FETCH_TAGS_CANCEL, onFetchTagsCancelAsync);
  yield takeLatest(FETCH_ARCHIVE_CANCEL, onFetchTagsCancelAsync);

}


export function* onUpdateTagAsync(payload) {
  try {
    yield put(showLoader(true));

    if (payload.autoCreateTechType) {
      const projectTechTypes = yield select((state) => state.project.techTyps);
      let technologyType = projectTechTypes.find(
        (techType) =>
          techType.technology_name === payload.autoCreateTechType.technology_name &&
          techType.instrument_type === payload.autoCreateTechType.instrument_type &&
          techType.product_description === payload.autoCreateTechType.product_description
      );

      if (!technologyType) {
        const techTypeResponse = yield call(crTechTypeAPI, [payload.autoCreateTechType]);

        if (techTypeResponse.status !== 200) {
          throw new Error("Technology type creation failed");
        }

        technologyType = techTypeResponse.data?.[0] || techTypeResponse.data;
        yield put(createTTSuccAct(techTypeResponse.data));
      }

      payload.tag = {
        ...payload.tag,
        technology_name: technologyType.technology_name,
        gen_technology_type: technologyType.technology_name,
        gen_instrument_type: technologyType.instrument_type,
        gen_prod_desc: technologyType.product_description,
        instrument_type: technologyType.instrument_type,
        product_description: technologyType.product_description,
        technology_id: technologyType.technology_id?.toString(),
        revision: technologyType.revision || payload.tag.revision,
      };
    }

    const response = yield call(updTagAPi, payload.tag);
    if (payload.tag?.loading) {
      delete payload.tag.loading
    }
    if (response.status === 200) {
      console.log("response", response)
      yield put(updTagSuccAct(payload));

      if (response.data?.pkgRevCommentAction == 'DELETED') {
        let respData = response?.data.pkgRevCommentData
        yield put(updatePkgCmntDelete(respData));

      } else {
        let respData = response?.data.pkgRevCommentData
        yield put(updatePkgCmntSuccess(respData));
      }


      yield put(showLoader(false));
    }
  } catch (e) {
    if (e?.response?.status === 403) { yield put(refreshApp(true)) }
    if (e?.response?.status === 413) {
      if (e?.response?.statusText) {
        yield put(updTagRes(payload.tag.tag_number + " data is too large, Please Verify!"));
      }
    }
    console.log("Error onUpdateTagAsync ", e);
    yield put(updtTagFailAct(e));
  }
}

export function* onUpdateTag() {
  yield takeLatest(UPDATE_TAGS_START, onUpdateTagAsync);
}

export function* onFetchADNameAsync(payload) {

  try {
    const response = yield call(
      getADSearchAPI,
      payload
    );
    console.log('from ad srch sga payload ', response)
    yield put(
      fetchADNSuccAct(
        response
      )
    )

  } catch (e) {
    if (e?.response?.status === 403) { yield put(refreshApp(true)) }
    yield put(fetchADNFailAct(e));
  }
}

export function* onFetchADName() {
  yield takeLatest(FETCH_ADNAMES_START, onFetchADNameAsync);
}


export function* onCrPkgAsync(payload, project_id) {
  try {
    const response = yield call(crpKGAPI, payload);
    if (response.status === 200) {
      localStorage.setItem("PNR", "PNR");
      yield put(crPkgSucc(response.data, payload.project_id));
      if (payload?.flag === "COPY") {
        yield put(copyPackgeSuccess());
        let respData = response?.data.pkgRevCommentData
        if (respData)
          yield put(updatePkgCmntSuccess(respData));
      }
      yield put(showLoader(false));
      /*try {
        const response = yield call(getProjectsAPI, payload.payload);
        yield put(fetchProjectSuccAct(response));
        localStorage.setItem("NR", "NR");
      } catch (e) {
        console.log("Error getProjectsAPI ", e);
        yield put(fetchProjectFailAct(e));
      }*/
    }
  } catch (e) {
    if (e?.response?.status === 403) { yield put(refreshApp(true)) }
    console.log("Error onCreateProjAsync ", e);
    yield put(createProjectFailure(e));
  }
}

export function* onCrPkg() {
  yield takeLatest(CREATE_PKG_START, onCrPkgAsync);
}


export function* onGetPkgsAsync(payload) {
  try {
    const prjId = payload.fPkgs.split("=")[1]
    console.log("onGetPkgsAsync payload", prjId);
    const response = yield call(getPkgsAPI, payload);
    if (response.status === 200) {
      yield put(fPkgsSuccAct(response.data));
      yield put(showLoader(false));
      yield put(fetchPkgCmntHistoryStart({ "project_id": prjId }));

    } else {
      yield put(fPkgsFailAct({ "errors": "get packages api failed" }));
      yield put(showLoader(false));
    }

  } catch (e) {
    if (e?.response?.status === 403) { yield put(refreshApp(true)) }
    console.log(e);
    yield put(fPkgsFailAct(e));
  }
}

export function* onGetPkgs() {
  yield takeLatest(FETCH_PKGS_START, onGetPkgsAsync);
}



export function* onUpPkgAsync(payload) {
  try {
    const response = yield call(upPkgAPI, payload);

    if (response.status === 200) {
      const { data } = response;

      if (data?.isPriceUpdate && data?.isPriceItems) {
        toastr.success("Commercial Items have been submitted for updated pricing.");
      }

      if (data?.status === 'error') {
        toastr.error(data.message);
      } else {
        yield put(upPkgSuccAct(data));
      }

      yield put(showLoader(false));
    }
  } catch (e) {
    if (e?.response?.status === 403) {
      yield put(userExpireLogout(true));
      yield put(refreshApp(true))
    }
    console.log("Error updateProjectFailAct ", e);
    yield put(upPkgFailAct(e));
  }
}

export function* onUpPkg() {
  yield takeLatest(UPDATE_PKG_START, onUpPkgAsync);
}


export function* onCreateTTAsync(payload) {
  try {
    const response = yield call(crTechTypeAPI, payload.cTT);
    if (response.status === 200) {
      yield put(createTTSuccAct(response.data));
      yield put(showLoader(false));

    }
  } catch (e) {
    if (e?.response?.status === 403) { yield put(refreshApp(true)) }
    console.log("Error onCreateProjAsync ", e);
    yield put(createTTFailureAct(e));
  }
}

export function* onCreateTT() {
  yield takeLatest(CREATE_TTYPE_START, onCreateTTAsync);
}


export function* onFetchTTAsync(payload) {
  try {
    // yield put(showLoader(true));
    // yield put(showLoader(true));
    const response = yield call(fetchTTAPI, payload.fTT);
    if (response.status === 200) {
      const ctrlState = yield select((state) => state.ctrl);

      //adding commercial products if not added
      const addedProd = response.data.map((i) => i.product_description);
      const nonAddedCommProd = ctrlState.techTypes.filter(
        (i) => i.type == "COMMERCIAL" && !addedProd.includes(i.description)
      );

      yield put(fTTActSuccAct(response.data));

      if (nonAddedCommProd.length != 0) {
        const profileState = yield select((state) => state.profile);

        const cttPayload = nonAddedCommProd.map((o) => ({
          project_id: ctrlState.pkg.project_id,
          package_id: ctrlState.pkg.package_id,
          package_name: ctrlState.pkg.package_name,
          technology_name: o.category,
          instrument_type: o.instrumentType,
          product_description: o.description,
          created_by: profileState.email,
          creation_date: getDt(new Date()),
          last_updatedby: profileState.email,
          last_updatedate: getDt(new Date()),
          selected: "Y",
          revision: payload.fTT.rid,
        }));
        yield put(createTTAct(cttPayload));
      }
    }
  } catch (e) {
    if (e?.response?.status === 403) {
      yield put(refreshApp(true));
    }
    console.log(e);
    yield put(fTTActFailAct(e));
  }
}

export function* onFetchTT() {
  yield takeLatest(FETCH_TTYPES_START, onFetchTTAsync);
}

export function* onFetchTagCountAsync(payload) {
  try {
    yield put(showLoader(true));
    const response = yield call(getTagCnt, payload);
    let tagCount = response.data;
    if (payload.payload.getCommercial == false) {
      tagCount["Documents_&_Order_Services_tag_count"] = 0;
      tagCount["Buy_Resale_tag_count"] = 0;
      tagCount["Accs,_Parts_&_Spares_tag_count"] = 0;
    }
    if (response.status === 200) {
      yield put(fetchTagCountSucc(tagCount))
      yield put(fTTAct({ project_id: payload.payload.pid, package_id: payload.payload.pkgid, rid: payload.payload.rev }))
      yield put(fetchTagsAct({ pid: payload.payload.pid, pkgid: payload.payload.pkgid, rid: payload.payload.rev, enable: payload.payload.enable, tagCnt: tagCount }))
      //yield put(bulkTagConfigStatusStart({ "project_id": payload.payload.pid, "package_id": payload.payload.pkgid }))
      // yield put(showLoader(false));
    }
  } catch (e) {
    if (e?.response?.status === 403) { yield put(refreshApp(true)) }
    yield put(showLoader(false));
    //console.log("Error onFetchTagCountAsync ", e);
    yield put(fetchTagCountFail(e));
  }
}

export function* onFetchTagCountPkgAsync(payload) {
  try {
    yield put(showLoader(true));
    yield put(fetchTagCountAct({ pid: payload.payload.pid, pkgid: payload.payload.pkgid, rev: payload.payload.rev, enable: "", type: "GET_TAGS" }));
    const result = yield take([FETCH_TAG_COUNT_SUCCESS]);
    const tagCount = yield select(getTagCount);

    const totalTagCount = Object.values(tagCount).reduce((a, b) => a + b, 0);

    while (true) {

      const tags = yield select(getTags);

      const delTags = yield select(getDelTags);

      if (totalTagCount == (tags.length + delTags.length)) {
        break;
      }
      yield delay(3000);
    }
    const tags = yield select(getTags);
    const delTags = yield select(getDelTags);
    const allTags = [...tags, ...delTags];

    const techTypes = yield select(getTechTypes);


    if (allTags.length > 0) {
      const uniqueTechNames = new Set();
      for (const techType of techTypes) {
        const { technology_name } = techType;
        uniqueTechNames.add(technology_name);
      }
      for (const technology_name of uniqueTechNames) {
        const formattedTechName = technology_name.replace(/\s+/g, '_') + '_tag_count';
        const currentTagCount = tagCount[formattedTechName] || 0;

        if (currentTagCount > 0) {
          const updatedTags = allTags
            .filter(i => i.gen_technology_type === technology_name)
            .map(tag => ({
              project_id: tag.project_id?.toString(),
              package_id: tag.package_id?.toString(),
              technology_id: tag.technology_id?.toString(),
              revision: tag.revision || "",
              tag_id: tag.tag_id?.toString(),
              tag_number: tag.tag_number || "",
              config_status: tag.config_status || "",
              gen_technology_type: tag.gen_technology_type || "",
              quote_hdr_id: "",
              quote_line_id: "",
            }));

          let pkgDtls = {
            project_id: allTags[0]?.project_id,
            package_id: allTags[0]?.package_id,
            revision: allTags[0]?.revision,
            mode: "UPDATE",
            ttlTagCount: currentTagCount,
          };

          const tagUpdPL = { recordsArr: updatedTags, pkg: pkgDtls, tagCount: currentTagCount, type: technology_name, status: 'START', from: 'singleClickMultiUpdate' };


          yield delay(2000)
          yield put(updateReviStartAct(tagUpdPL));

        }
      }

      yield put(fetchTagCountPkgSucc())
      yield put(resetTagsAct());
    }
    else {
      yield put(fetchTagCountPkgSucc())
      yield put(resetTagsAct());
      toastr.error("There are no tags in this package to update");
    }

  } catch (e) {
    if (e?.response?.status === 403) {
      yield put(refreshApp(true));
    }
    yield put(showLoader(false));
    yield put(fetchTagCountFail(e));
  }
}


export function* onFetchTagCount() {
  yield takeLatest(FETCH_TAG_COUNT_START, onFetchTagCountAsync);
}

export function* onFetchTagPkgCount() {
  const response = yield takeLatest(FETCH_TAG_COUNT_PKG_START, onFetchTagCountPkgAsync);

  const tags = yield select(getTags);
  if (tags) {
    //console.log("tags in saga",tags);
  }


}
export function* onCopyTag() {
  yield takeLatest(COPY_TAGS_START, onCopyTagAsync);
}
export function* onCopyTagAsync(payload) {
  try {
    const state = yield select(state => state.ctrl);
    const response = yield call(copyTagAPI, payload);
    if (response.status === 200) {
      yield put(resetTagsAct());
      yield put(fetchTagCountAct({ pid: state.pkg.project_id, pkgid: state.pkg.package_id, rev: state.pkg.active_revision, enable: "Y", type: "GET_TAGS" }))
      yield put(createCopyTagSucc(response.data));

    }
  } catch (e) {
    if (e?.response?.status === 403) { yield put(refreshApp(true)) }
    //console.log("Error onCopyTagAsync ", e);
    yield put(createCopyTagFailure(e));
  }
}
export function* onRemoveTag() {
  yield takeLatest(REMOVE_TAGS_START, onRemoveTagAsync);
}
export function* onRemoveTagAsync(payload) {
  try {
    const state = yield select(state => state.ctrl);
    const response = yield call(removeTagAPI, payload);
    if (response.status === 200) {
      yield put(resetTagsAct());
      yield put(fetchTagCountAct({ pid: state.pkg.project_id, pkgid: state.pkg.package_id, rev: state.pkg.active_revision, enable: "Y", type: "GET_TAGS" }))
      yield put(removeChildTagSucc(response.data));

    }
  } catch (e) {
    if (e?.response?.status === 403) { yield put(refreshApp(true)) }
    console.log("Error onremoveTagAsync ", e);
    yield put(removeChildTagFailure(e));
  }
}

export function* onGetModelBreakAsync(payload) {

  try {
    yield put(showLoader(true));
    const response = yield call(getModelBreak, payload);
    //  console.log({response});
    yield put(fmodelbreakSuccAct(response));

    yield put(showLoader(false));

  } catch (e) {
    yield put(showLoader(false));
    console.log({ e });

    yield put(fmodelbreakFailAct(e));

  }

}

export function* onGetModelBreak() {

  yield takeLatest(FETCH_MODEL_BREAK_START, onGetModelBreakAsync);

}

// projSaga
export function* onGetModelBreakMulAsync(payload) {
  try {
    yield put(showLoader(true));
    const response = yield call(getModelBreakMulTag, payload);
    yield put(fModelBreakMulSuccAct(response));
    yield put(showLoader(false));
  } catch (e) {
    yield put(showLoader(false));
    // console.log({ e });
    yield put(fModelBreakMulFailAct(e));
  }
}

export function* onGetModelBreakMulti() {
  yield takeLatest(FETCH_MODEL_BREAK_MUL_START, onGetModelBreakMulAsync);
}

// export function* addUpdatePriceConfigAction(payload) {
//   const {payload: {cTT, pl}} = payload
//   try {

//     const response = yield call(addUpdatePriceConfig , cTT); 
//     if (response.status === 200) {
//       if(response.includes("Error")){
//         pl['configuration_import'] = "FAILURE"
//       } else {
//         pl['configuration_import'] = "SUCCESS"
//         pl['cloud_config_id'] = response.data
//       }

//       yield put(updTagAct(pl));
//       yield put(showLoader(false));
//     }
//   } catch (e) {
//     if(e?.response?.status === 403){ yield put(refreshApp(true))}
//     console.log("Error ", e);
//     pl['configuration_import'] = "FAILURE"
//     yield put(updTagAct(pl));
//     yield put(addUpdatePriceConfigFailure(e));
//   }
// }

export function* addUpdatePriceConfigAction(payload) {
  const { payload: { cTT, pl } } = payload
  try {
    const response = yield call(addUpdatePriceConfig, cTT);
    if (typeof response.data === "object") {
      pl['configuration_import'] = "FAILURE"
    }

    if (typeof response.data === "number") {
      pl['configuration_import'] = "SUCCESS"
      pl['cloud_config_id'] = response.data
    }

    if (typeof response.data === "string" && response.data.includes("Error")) {
      pl['configuration_import'] = "FAILURE"
    }
    pl['loading'] = "INIT"
    yield put(updTagAct(pl));
    yield put(showLoader(false));

  } catch (e) {
    if (e?.response?.status === 403) { yield put(refreshApp(true)) }
    pl['configuration_import'] = "FAILURE"
    yield put(updTagAct(pl));
    yield put(addUpdatePriceConfigFailure(e));
  }
}

export function* addUpdatePriceConfigSaga() {
  yield takeLatest(ADD_UPDATE_PRICE_CONFIG, addUpdatePriceConfigAction);
}


function keepProjectName(fullName) {
  const parts = fullName.split("_");
  const projectName = "_" + parts[parts.length - 1];
  return projectName;
}




export function* onGetReportAsync(payload) {
  yield put(startLoader());
  try {
    const env = getEnvironment();
    const project_name = yield select(state => state.ctrl.data.project_name);
    const lineItems = payload.payload.items;
    const reportInput = payload.pkgDetail.reportinput;
    const batchSize = 20;
    const maxBatches = Math.ceil(Math.max(lineItems.length, reportInput.length) / batchSize);

    let isMessageDisplayed = false;

    for (let batchIndex = 0; batchIndex < maxBatches; batchIndex++) {
      const lineItemsBatch = lineItems.slice(batchIndex * batchSize, (batchIndex + 1) * batchSize);
      const reportInputBatch = reportInput.slice(batchIndex * batchSize, (batchIndex + 1) * batchSize);

      const batchPayload = {
        ...payload,
        payload: {
          ...payload.payload,
          items: lineItemsBatch,
        },
        pkgDetail: {
          ...payload.pkgDetail,
          reportinput: reportInputBatch,
        },
      };

      console.log("Batch Payload:", batchPayload);

      let response = null;
      try {
        yield delay(2000);
        response = yield call(getReportAPI, batchPayload);
        console.log("Response:", response);
      } catch (apiError) {
        console.error("API Error:", apiError);
        yield put(getReportIDUpdate({
          "status": "FAILURE",
          "message": "Failed to fetch report data. Please try again later.",
        }));
        continue; // Skip to the next batch
      }

      if (response && typeof response === 'object' && response.id) {
        if (!isMessageDisplayed) {
          yield put(getReportIDUpdate({
            "status": "SUCCESS",
            "message": "Reports are getting generated and will be delivered via mail. Each email contains reports for up to 20 tags.",
          }));
          isMessageDisplayed = true;
        }

        const task_id = response.id;
        const zipName = `${project_name}`;

        // batchPayload.pkgDetail.zipfilename = zipName;
        batchPayload.pkgDetail.zipfilename = response.zip_name.split("MyProject Workspace")[1].trim();
        batchPayload.pkgDetail.task_id = task_id;

        console.log("Batch Payload Updated:", batchPayload);
      } else {
        yield put(getReportIDUpdate({
          "status": "FAILURE",
          "message": "Something went wrong with Report Hub API, Please try after sometime!",
        }));
        batchPayload.pkgDetail.state = "Failed to Submit";
      }
      yield call(reportHubStatus, batchPayload.pkgDetail);
    }
  } catch (e) {
    console.error("Error in onGetReportAsync:", e);
    yield put(getReportIDUpdate({
      "status": "FAILURE",
      "message": "Something went wrong with Report Hub API, Please try after sometime!",
    }));
  }
  yield put(stopLoader());
}

export function* onGetReport() {

  yield takeLatest(GET_REPORT_START, onGetReportAsync);
}

const getReportBatchErrorMessage = (errorPayload) => {
  if (!errorPayload) {
    return 'Failed to submit report batch.';
  }

  if (typeof errorPayload === 'string') {
    return errorPayload;
  }

  if (Array.isArray(errorPayload)) {
    return getReportBatchErrorMessage(errorPayload[0]);
  }

  if (typeof errorPayload === 'object') {
    return getReportBatchErrorMessage(errorPayload.message)
      || getReportBatchErrorMessage(errorPayload.detail)
      || getReportBatchErrorMessage(errorPayload.failure_summary)
      || getReportBatchErrorMessage(errorPayload.error)
      || getReportBatchErrorMessage(errorPayload.title)
      || getReportBatchErrorMessage(errorPayload.errors)
      || getReportBatchErrorMessage(errorPayload.non_field_errors)
      || Object.values(errorPayload)
        .map((value) => getReportBatchErrorMessage(value))
        .find((value) => value && value !== 'Failed to submit report batch.')
      || 'Failed to submit report batch.';
  }

  return 'Failed to submit report batch.';
};

export function* onSubmitReportBatchesAsync(action) {
  yield put(showLoader(true));
  try {
    const response = yield call(postReportBatchesAPI, action.payload);

    if (response.status === 200 || response.status === 201) {
      yield put(submitReportBatchesSuccess(response.data));
      yield put(showLoader(false));
      return;
    }

    yield put(submitReportBatchesFailure(response.data));
  } catch (e) {
    if (e?.response?.status === 403) { yield put(refreshApp(true)) }

    const errorPayload = e?.response?.data || e;

    yield put(submitReportBatchesFailure({
      raw: errorPayload,
      message: getReportBatchErrorMessage(errorPayload),
      status: e?.response?.status,
    }));
    yield put(showLoader(false));
  }
}

export function* onSubmitReportBatches() {
  yield takeLatest(REPORT_BATCHES_START, onSubmitReportBatchesAsync);
}

export function* onFetchReportHubStatusAsync(payload) {
  try {
    const response = yield call(getReportHubStatus, payload);
    // console.log(response.status)
    if (response.status === 200) {
      yield put(fetchReportHubStatusSucc(response.data));
    }


  } catch (e) {
    console.log(e);
    if (e?.response?.status === 403) { yield put(refreshApp(true)) }
    console.log(e);
  }
}

export function* onFetchReportHubStatus() {
  yield takeLatest(FETCH_REPORT_HUB_STATUS_START, onFetchReportHubStatusAsync)
}



export function* onGetReportHubTaskStatusAsync(payload) {
  try {
    console.log("payloafd", payload);
    const response = yield call(getRptHubTkStt, payload.taskID);

    let tagRepHubStsUpdPL = {
      "task_id": payload.taskID,
      "state": response.status,
      "failure_desc": "",
    }
    if (response.state === "FAILURE") {
      tagRepHubStsUpdPL.failure_desc = response.info;
    }

    if (response && response.state != payload.status) {
      const resUpd = yield call(reportHubStatusUpd, tagRepHubStsUpdPL);
      if (resUpd) {
        yield put(reportHubTaskStatusUpdate(tagRepHubStsUpdPL));
      }
    } else {
      yield put(reportHubTaskStatusUpdate(tagRepHubStsUpdPL));
    }


  } catch (e) {
    console.log(e);
    if (e?.response?.status === 403) { yield put(refreshApp(true)) }
    console.log(e);
  }
}


export function* onGetReportHubTaskStatus() {
  yield takeLatest(REPORTHUB_TASK_STATUS_START, onGetReportHubTaskStatusAsync)
}

export function* onSendEmailAsync(payload) {
  try {
    const response = yield call(emailNotiSendAPI, payload);
    if (response.status === 200) {

      yield put(sendMailSuccess(response));
      //yield put(showLoader(false));

    }
  } catch (e) {
    // if(e?.response?.status === 403){ yield put(refreshApp(true))}
    // console.log("Error onCreateProjAsync ", e);
    yield put(sendMailFailure(e));
  }
}

export function* onSendEmail() {
  yield takeLatest(SEND_MAIL_START, onSendEmailAsync);
}


// ----Bulk Tag Config----

export function* onBulkTagConfigAsync(data) {

  try {

    const response2 = yield call(postBulkConfigtag, data.payload);
    console.log(response2)
    console.log(response2.status)
    if (response2.status === 201) {
      console.log(response2)
      yield put(bulkTagConfigSuccess(response2.data));
    } else {

      console.log("Error onBulkTagConfigAsync ");
      yield put(bulkTagConfigFailure("Error onBulkTagConfigAsync "));
    }

    /*try {
      const response = yield call(getProjectsAPI, payload.payload);
      yield put(fetchProjectSuccAct(response));
      localStorage.setItem("NR", "NR");
    } catch (e) {
      console.log("Error getProjectsAPI ", e);
      yield put(fetchProjectFailAct(e));
    }*/

  } catch (e) {

    console.log("Error onBulkTagConfigAsync ", e);
    yield put(bulkTagConfigFailure(e));
  }
}

export function* onBulkTagConfigStatusAsync(data) {

  try {
    let abortController = new AbortController();
    abortControllerArrBulkConfig.push(abortController)
    console.log(data)
    const response2 = yield call(bulkConfigtagsstus, { ...data.payload, signal: abortController.signal });
    console.log(response2)
    if (response2.status === 200) {
      console.log(response2)
      yield put(bulkTagConfigStatusSuccess(response2.data));
    } else {

      console.log("Error onBulkTagConfigStatusAsync ");
      yield put(bulkTagConfigStatusFailure("Error onBulkTagConfigStatusAsync "));
    }

    /*try {
      const response = yield call(getProjectsAPI, payload.payload);
      yield put(fetchProjectSuccAct(response));
      localStorage.setItem("NR", "NR");
    } catch (e) {
      console.log("Error getProjectsAPI ", e);
      yield put(fetchProjectFailAct(e));
    }*/

  } catch (e) {

    console.log("Error onBulkTagConfigStatusAsync ", e);
    yield put(bulkTagConfigStatusFailure(e));
  }
}

export function* onBulkTagConfigCancelAsync(data) {

  try {

    console.log(data)
    const response2 = yield call(cancelBulkConfigtag, data.payload);
    console.log(response2)
    if (response2.status === 200) {
      console.log(response2)
      yield put(bulkTagConfigCancelSuccess(response2.data));
    } else {

      console.log("Error onBulkTagConfigAsync ");
      yield put(bulkTagConfigCancelFailure("Error onBulkTagConfigCancelAsync "));
    }

    /*try {
      const response = yield call(getProjectsAPI, payload.payload);
      yield put(fetchProjectSuccAct(response));
      localStorage.setItem("NR", "NR");
    } catch (e) {
      console.log("Error getProjectsAPI ", e);
      yield put(fetchProjectFailAct(e));
    }*/

  } catch (e) {

    console.log("Error onBulkTagConfigCancelAsync ", e);
    yield put(bulkTagConfigCancelFailure(e));
  }
}


export function* onBulkTagConfig() {
  yield takeLatest(BULK_TAG_CONFIG_START, onBulkTagConfigAsync);
}


export function* onBulkTagConfigStatus() {
  yield takeLatest(BULK_TAG_CONFIG_STS_START, onBulkTagConfigStatusAsync);
}

export function* onBulkTagConfigCancel() {
  yield takeLatest(BULK_TAG_CONFIG_CANCEL_START, onBulkTagConfigCancelAsync);
}
// ---- Bulk TAG configuration--end--


//---for pricing----
export function* postPricingData(payload) {
  const state = yield select(state => state.profile);
  console.log("values:", state);
  console.log("v:", payload);
  const tags = payload.payload
  const costWorkPL = tags.map(tag => ({
    tag_id: (tag.tag_id).toString() || "",
    tag_number: tag.tag_number || "",
    project_id: (tag.project_id).toString() || "",
    package_id: (tag.package_id).toString() || "",
    technology_id: (tag.technology_id).toString() || "",
    //state_name:tag.state_name || "", //NEW
    state_position: 0,
    //status: tag.status || "",  //NEW
    size: "",
    rating: "",
    valve_configur: "",
    body_style: "",
    body_material: "",
    model_code: tag.pur_mod_num_part1 || "",
    qty: tag.quantity,
    project: "",
    country: "",
    pricing_policy: "",
    gm_valve: 0,
    multiplier_for_RSP: 0,
    manufacturing_location: "",
    engineering_EPC: "",
    end_User: "",
    distributer_impact_partner: "",
    contractor_integrator: "",
    plant_Country: "",
    Date: "",
    vanessa_Quote_No: "",
    Rev: "",
    std_cost_id: 0,
    extra_cost_id: 0,
    option_glpe_id: 0,
    total_cost_id: 0,
    special_option_id: 0,
    base_glpe_price: "",
    base_coste_calc_price: "",
    cost_reduction_setup: "",
    selected_extra_costlist: "",
    delta_cost_price_glpe: "",
    price: "",
    machine_setup_pn: "",
    cost_reduction_machine: "",
    pmi: "",
    additional_extras_manually: "",
    total_cost: "", //tag.purchase_total_price || ""
    base_costs_increase: "",
    special_activity: "",
    full_absorbed_cost: "",
    unit_sales_price: "",
    revision_ppa: "",
    revision_prjws: "",
    without_multipliers: "",
    created_by: state.email,
    creation_date: getDt(new Date()), //tag.creation_date
    last_updated_by: state.email,
    last_updated_date: getDt(new Date()), //tag.last_updatedate
    start_date_active: tag.creation_date,
    end_date_active: tag.end_date,
    enabled_flag: true
  }));

  let pkgDtls =
  {
    project_id: tags.project_id,
    package_id: tags.package_id,
    revision: tags.revision,
    mode: "UPDATE",
    ttlTagCount: tags.length,
    apiAction: 'UpdPPAprice',
    apiSuccess: 'API_SUCCESS'
  };


  const updatedTags = tags.map(tag =>
  ({
    project_id: (tag.project_id).toString(),
    package_id: (tag.package_id).toString(),
    technology_id: (tag.technology_id).toString(),
    revision: tag.pur_config_rev_num || "",
    tag_id: (tag.tag_id).toString(),
    tag_number: tag.tag_number || "",
    config_status: tag.config_status || "",
    gen_costing_status: "IN PROCESS", //if the value is this then grey it out.
    gen_technology_type: tag.gen_technology_type || "",
  }))

  const tagUpdPL = { recordsArr: updatedTags, pkg: pkgDtls, type: 'Vanessa', status: 'START', from: 'singleClickMultiUpdate', apiAction: 'UpdPPAprice' }

  //console.log(tagUpdPL, "tagUpdPL is shown:");

  try {
    const response = yield call(pricingAPI, costWorkPL);
    if (response.status === 200) {
      yield put(updateReviStartAct(tagUpdPL)); //(updateReviStartAct
      yield put(showLoader(false));
      //yield put(postpricingdataSuccess({data: response.data, updTags: updatedTags}));
    }
  } catch (e) {
    if (e?.response?.status === 403) { yield put(refreshApp(true)) }
    console.log("Error postPricingData ", e);
    yield put(postpricingdataFailure(e));
  }
}

export function* onPostPricingData() {
  yield takeLatest(SEND_PRICING_DATA_START, postPricingData);
}

//--pricing API end ---

export function* submitPriceItem(payload) {
  yield put(showLoader(true));
  try {
    const response = yield call(itemPriceSubmitApi, payload);
    if (response.status === 201) {
      toastr.success("Items submitted successfully!");
      yield put(priceItemSuccess(payload));
    } else {
      console.log("Error onSubmitPriceItem");
      toastr.error("Something went wrong while submitting items!");
      yield put(priceItemFailure("onSubmitPriceItem"));
    }
  } catch (e) {
    toastr.error("Something went wrong while submitting items!");
    console.log("Error onSubmitPriceItem", e);
    yield put(priceItemFailure(e));
  } finally {
    yield put(showLoader(false));
  }
}

export function* onSubmitPriceItem() {
  yield takeLatest(PRICE_ITEM_START, submitPriceItem);
}

export function* onItemPriceStatusAsync(data) {
  try {
    let abortController = new AbortController();
    abortControllerArrBulkConfig.push(abortController)
    const response = yield call(itemPriceStatusApi, { ...data.payload, signal: abortController.signal });
    if (response.status === 200) {
      yield put(itemPriceStatusSuccess(response.data));
    } else {
      console.log("Error onItemPriceStatusAsync");
      yield put(itemPriceStatusFailure("onItemPriceStatusAsync"));
    }

  } catch (e) {
    console.log("Error onItemPriceStatusAsync", e);
    yield put(itemPriceStatusFailure(e));
  }
}

export function* onItemPriceStatus() {
  yield takeLeading(ITEM_PRICE_STS_START, onItemPriceStatusAsync);
}
// ---Quote no search
export function* onQuoteSearchAsync(data) {
  try {
    yield put(showLoader(true));
    const responseObj = yield call(quoteSearchApi, data.payload);
    if (responseObj?.response?.data?.detail) {
      yield put(quoteSearchSuccess({ message: responseObj.response.data.detail }));
    }
    if (responseObj?.package) {
      yield put(quoteSearchSuccess(responseObj));
    }

    yield put(showLoader(true));

  } catch (e) {
    yield put(quoteSearchFailure(e));
    yield put(showLoader(true));
  }
}

export function* onQuoteSearch() {
  yield takeLatest(QUOTE_SEARCH_START, onQuoteSearchAsync);
}
export function* onFetchTagsWithCmntAsync(data) {
  try {
    console.log("in saga fetch tags with cmnt")
    // let abortController = new AbortController();
    // abortControllerArrBulkConfig.push(abortController)
    let abortController2 = new AbortController();
    abortControllerArrBulkConfig.push(abortController2)

    const response = yield call(getTagsApiWithRemarks, { ...data.payload, signal: abortController2.signal });
    console.log(response?.status)
    if (response?.status !== 200) {
      console.log("Error onItemPriceStatusAsync");
      yield put(fetchTagsWithCmntFailure("onItemPriceStatusAsync"));
    }
    if (response?.status === 200) {
      const tagsWithCmntdata = response?.data?.length > 0 ? response?.data : []
      let respData = { 'restData': tagsWithCmntdata, 'pkgDetails': data.payload }
      yield put(fetchTagsWithCmntSuccess(respData));

    }

  }
  catch (e) {
    console.log("Error onItemPriceStatusAsync");
    yield put(fetchTagsWithCmntFailure(e));
  }
}

export function* onFetchTagsWithCmnt() {
  yield takeEvery(FETCH_TAGS_WITH_CMNT_START, onFetchTagsWithCmntAsync);
}


export function* onFetchPkgCmntHistoryAsync(data) {
  try {
    console.log("in saga fetch Pkg with cmnt history", data)
    // let abortController = new AbortController();
    // abortControllerArrBulkConfig.push(abortController)
    // let abortController2 = new AbortController();
    // abortControllerArrBulkConfig.push(abortController2)

    const response = yield call(getPkgHistoryCmnt, data.payload);
    console.log(response?.status)
    if (response?.status !== 200) {
      console.log("Error onFetchPkgCmntHistoryAsync");
      yield put(fetchPkgCmntHistoryFailure("API endpoint failure"));
    }
    if (response?.data?.length > 0 && response?.status === 200) {
      let respData = response?.data
      yield put(fetchPkgCmntHistorySuccess(respData));

    }

  }
  catch (e) {
    console.log("Error onItemPriceStatusAsync");
    yield put(fetchTagsWithCmntFailure(e));
  }
}
export function* onFetchPkgCmntHistory() {
  yield takeEvery(FETCH_PKG_CMT_HISTORY_START, onFetchPkgCmntHistoryAsync);
}


export function* onUpdatePkgCmntAsync(data) {
  try {
    console.log("in saga Pkg cmnt update", data)
    // let abortController = new AbortController();
    // abortControllerArrBulkConfig.push(abortController)
    // let abortController2 = new AbortController();
    // abortControllerArrBulkConfig.push(abortController2)

    const response = yield call(updatePkgRevComment, data.payload);
    console.log(response?.status)
    if (response?.status !== 200) {
      console.log("Error onUpdatePkgCmntAsync");
      yield put(updatePkgCmntFailure("API endpoint failure"));
    }
    if (response?.status === 200) {
      let respData = response?.data
      yield put(updatePkgCmntSuccess(respData));
      yield put(changeLoadingPhaseStatus({ action: "UPDATE_PKG_CMT", phase: "SUCCESS" }));

    }

  }
  catch (e) {
    console.log("Error onItemPriceStatusAsync");
    yield put(fetchTagsWithCmntFailure(e));
  }
}

export function* onUpdatePkgCmnt() {
  yield takeEvery(UPDATE_PKG_CMT_START, onUpdatePkgCmntAsync);
}

export function* onEditPkgCmntAsync(data) {
  try {
    const response = yield call(editPkgRevComment, data.payload);
    if (response?.status !== 200) {
      yield put(editPkgCmntFailure("API endpoint failure"));
      return;
    }

    const respData = response?.data;
    yield put(editPkgCmntSuccess(respData));
    yield put(changeLoadingPhaseStatus({ action: "EDIT_PKG_CMT", phase: "SUCCESS" }));
  } catch (e) {
    yield put(editPkgCmntFailure(e));
  }
}

export function* onEditPkgCmnt() {
  yield takeEvery(EDIT_PKG_CMT_START, onEditPkgCmntAsync);
}


export function* confITModelBreakdownAction(payload) {
  const { payload: { cTT, pl } } = payload
  try {
    const response = yield call(confITModelBreakdownAPI, cTT);

    if (response?.status === 200) {

      if (response.data.cloud_config_id) {
        pl['configuration_import'] = "SUCCESS"
        pl['cloud_config_id'] = response.data.cloud_config_id
      } else if (response.data.success == false || response.data.configurationStatus == "Invalid") {
        pl['configuration_import'] = "FAILURE"
      }else if (response.data.err_code == -1) {
        pl['configuration_import'] = "FAILURE"
      } else {
        pl['configuration_import'] = "FAILURE"
      }

    } else {
      pl['configuration_import'] = "FAILURE"
    }

    pl['loading'] = "INIT"
    yield
    yield put(updTagAct(pl));
    yield put(showLoader(false));

  } catch (e) {
    if (e?.response?.status === 403) { yield put(refreshApp(true)) }
    pl['configuration_import'] = "FAILURE"
    yield put(updTagAct(pl));
    yield put(confITModelBreakdownFailure(e));
  }
}

export function* confITModelBreakdownSaga() {
  yield takeLatest(CONF_IT_MODEL_STRING_BREAKDOWN_START, confITModelBreakdownAction);
}

